import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import useInheritParams from 'hooks/useInheritParams';
import { Content, getContentImageUrl } from '../../lib/FL';
import PreviewOverlay from '../atom/PreviewOverlay';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import ContentPreviewModal from '../modal/ContentPreviewModal';

import styles from './BasicContentCard.module.scss';

type Props = {
  content: Content;
};

const BasicContentCard: React.FC<Props> = ({ content }) => {
  const { inheritParams } = useInheritParams();
  const dispatch = useContext(ModalDispatchContext);
  const createPreviewModal = () => <ContentPreviewModal content={content} />;

  if (content.en_name === 'top') {
    return (
      <li className={styles.card}>
        <Link
          className={styles.card__button}
          to={{
            pathname: '/',
            search: inheritParams,
          }}
        >
          <div className={styles.thumbnail}>
            <img
              src={getContentImageUrl(content)}
              alt={content.ja_name}
              className={styles.thumbnail__img}
            />
          </div>
          <div className={styles.card__info}>
            <h2 className={styles.card__title}>{content.ja_name}</h2>
            <div className={styles.card__description}>{content.description}</div>
            <div className={styles.card__link}>デザインの確認はこちら</div>
          </div>
        </Link>
      </li>
    );
  }

  const CardContents: React.FC = () => (
    <>
      <div className={styles.thumbnail}>
        <img
          src={getContentImageUrl(content)}
          alt={content.ja_name}
          className={styles.thumbnail__img}
        />
        <PreviewOverlay />
      </div>
      <div className={styles.card__info}>
        <h2 className={styles.card__title}>{content.ja_name}</h2>
        <div className={styles.card__description}>{content.description}</div>
      </div>
    </>
  );

  return (
    <li className={styles.card}>
      <button
        className={`${styles.card__button} ${styles.card__button_pc} onMouseShowPreviewOverlay`}
        onClick={() => dispatch(createPreviewModal)}
        type='button'
      >
        <CardContents />
      </button>
      <Link
        className={`${styles.card__button} ${styles.card__button_sp}`}
        to={`/content/${content.en_name}`}
        target='_blank'
      >
        <CardContents />
      </Link>
    </li>
  );
};

export default BasicContentCard;
